module.exports = __webpack_public_path__ + "static/img/hzms@2x.b88452b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/ktb_min/hzms@2x.png
// module id = BGuU
// module chunks = 69